// lazySystemDatabaseTypes.js — system types that get a catch-all collection row on first node

export const LAZY_SYSTEM_DATABASE_TYPE_KEYS = new Set([
  'PHOTO',
  'VIDEO',
  'DOCUMENT',
  'FILE',
  'ARTICLE',
  'EVENT',
  'COMMENT',
]);

export function isLazySystemDatabaseType(typeKey) {
  return LAZY_SYSTEM_DATABASE_TYPE_KEYS.has(String(typeKey || '').trim().toUpperCase());
}
